export default __webpack_public_path__ + "static/media/decada-0080-0005-min.fc9849b1.jpg";